import { CheckCircle2 } from "lucide-react";

import type { AudienceItem } from "@/content/comparisons/schema";

interface AudienceSectionProps {
  rebolt: {
    heading: string;
    subtitle: string;
    items: AudienceItem[];
  };
  competitor: {
    heading: string;
    subtitle: string;
    items: AudienceItem[];
  };
}

function AudienceBlock({
  heading,
  subtitle,
  items,
  variant,
}: {
  heading: string;
  subtitle: string;
  items: AudienceItem[];
  variant: "rebolt" | "competitor";
}) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-4xl">
          {heading}
        </h2>
        <p className="mt-2 text-lg text-ash-500">{subtitle}</p>
      </div>
      <ul className="space-y-4">
        {items.map((item) => (
          <li key={item.bold} className="flex gap-3">
            <CheckCircle2
              className={`mt-0.5 size-5 shrink-0 ${variant === "rebolt" ? "text-rebolt-500" : "text-ash-400"}`}
            />
            <p className="text-lg text-ash-700">
              <strong className="text-ash-900">{item.bold}</strong> {item.detail}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function AudienceSection({ rebolt, competitor }: AudienceSectionProps) {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-4xl space-y-16 px-6">
        <AudienceBlock heading={rebolt.heading} subtitle={rebolt.subtitle} items={rebolt.items} variant="rebolt" />
        <AudienceBlock
          heading={competitor.heading}
          subtitle={competitor.subtitle}
          items={competitor.items}
          variant="competitor"
        />
      </div>
    </section>
  );
}
